require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./videos-ultras-sunset.json") })
        }
      }, "path---videos-ultras-sunset");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---videos-ultras-sunset!./.cache/json/videos-ultras-sunset.json
// module id = 956
// module chunks = 231608221292675